<template>
  <div>
    <div class="card-home-shortcuts">
      <v-layout row wrap pa-3>
        <!-- Columna 1: Bienvenida -->
        <v-flex xs12 md6 style="padding-right: 2.5rem">
          <v-layout align-center fill-height>
            <div class="text-center">
              <h1 class="welcome-title font-blue-bice">Te damos la bienvenida a</h1>
              <h1 class="welcome-subtitle font-blue-bice"><b>Somos BICE</b></h1>
              <p class="welcome-text font-blue-bice">
                Aquí encontrarás información relevante para tu desarrollo y gestión como colaborador.
              </p>
            </div>
          </v-layout>
        </v-flex>

        <!-- Columna 2: Accesos directos -->
        <v-flex xs12 md6>
          <v-container class="px-0 py-0">
            <h2 class="title pa-2 mb-3 font-blue-bice">Accesos directos</h2>
            <div class="shortcut-grid">
              <div v-for="shortcut in banners" :key="shortcut.id">
                <v-card class="shortcut-card" @click="goToLink(shortcut)">
                  <div class="card-content">
                    <div class="icon-container">
                      <img :src="shortcut.image" alt="icon" class="shortcut-icon">
                    </div>
                    <div class="text-container">
                      <p class="title-with-icon">{{ shortcut.title }}</p>
                    </div>
                    <div class="arrow-container">
                      <img src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/flecha.png" height="16px" alt="icono" class="arrow-icon">
                    </div>
                  </div>
                </v-card>
              </div>
            </div>
          </v-container>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data: () => ({
    banners: []
  }),
  methods: {
    ...mapActions("links", ["fetchLinks"]),
    async getBanners() {
      const view_as = localStorage.getItem("view_as");
      const res = await this.fetchLinks(view_as);
      this.banners = res.links;
    },
    goToLink(shortcut) {
      const target = shortcut.is_blank ? "_blank" : "_self";
      window.open(shortcut.url, target);
    },
  },
  created() {
    this.getBanners();
  },
};
</script>

<style scoped>
.title {
  font-weight: 600;
  font-size: 2rem !important;
  font-family: "Titillium Web" !important;
  /* color: #28385C; */
}
.pa-2 {
  padding: 0.625rem;
}
.shortcut-card {
  cursor: pointer;
  box-shadow: 0rem 0.125rem 0.5rem rgba(0, 0, 0, 0.1);
  border-radius: 0.625rem;
  padding: 10px 8px;
}
.card-content {
  display: flex;
  align-items: center;
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
}
.welcome-title {
  font-weight: 400;
  font-size: 2.25rem;
  line-height: 3rem;
  /* color: #232272; */
}
.welcome-subtitle {
  font-weight: 600;
  font-size: 2.25rem;
  line-height: 3rem;
  display: block;
  margin-bottom: 2.5rem;
  /* color: #232272; */
}
.welcome-text {
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.5rem;
  /* color: #232272; */
  margin: 0;
}
.shortcut-icon {
  width: 32px;
  height: 32px;
  object-fit: cover;
}

.title-with-icon {
  font-size: 1rem;
  font-weight: 400;
  text-align: left;
  line-height: 1.5rem;
  margin: 0px
}

.icon-container,
.arrow-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
}
.icon-container{
  width: 31px;
}
.arrow-container{
  width: 28px;
}

.text-container {
  flex: 1;
  display: flex;
  align-items: center;
}

.card-home-shortcuts {
  border: 0.0625rem solid #2424261A;
  border-radius: 0.625rem;
  background-color: #fff;
  position: relative; 
  top: -2.5rem;
  box-shadow: 0px 0.625rem 1.25rem rgba(0, 0, 0, 0.2);
}

/* Estilos para el grid */
.shortcut-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1.4rem;
}
</style>
